import { app } from '../../../app';
import { Controller } from './whats-new.controller';

app.component('companyWhatsNew', {
    bindings: {
        updateId: '<',
    },
    controller: Controller,
    templateUrl : require('./whats-new.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/whats-new/whats-new.component.js